import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function LibraryBooksIcon(props: IconProps) {
    return <Icon {...props} iconKey={"library_books"}/>
}
